import { useSelector } from "react-redux";
import { selectProductData } from "~/redux/products/productsSelectors";
import { type SrpProductData } from "~/utils/models";
import { useAddProductToWishlistFlow } from "~/common/hooks/useAddProductToWishlistFlow";
import { useCallback } from "react";
import { IconClickable } from "~/common/components/icon/IconClickable";
import { IconType } from "~/common/components/icon/IconType";

export const AddToWishlistAction = ({ productCode, hidden, ...rest }: { productCode: string; hidden?: boolean }) => {
  const product = useSelector(selectProductData(productCode)) as SrpProductData;
  const [addToWishlistClick, addToWishlistModal] = useAddProductToWishlistFlow({ productInput: product });

  const openWishlist = useCallback(() => {
    addToWishlistClick();
  }, [addToWishlistClick]);

  return (
    <>
      <IconClickable
        className={hidden ? "v-hidden" : ""}
        data-test-id={"tabular-view-action-button-wishlist"}
        type={IconType.Bookmark}
        inverted={true}
        onIconClick={openWishlist}
        {...rest}
      />
      {addToWishlistModal}
    </>
  );
};
